<template>
    <QuestionBox :title="step.question" :text="$t('module.audioListen')" />
    <div class="m-audio m-block u-px20 u-py20 u-bgWhite u-border u-shadow u-br">
        <div class="m-block__inner">
            <div class="m-audio__imageHolder u-mb20 u-posRelative">
                <div class="m-audio__flipper" :class="{ '-flipped': !showImage1 }">
                    <div class="m-audio__side -front">
                        <img 
                            v-if="step.image1" 
                            class="m-audio__image" 
                            :src="step.image1" 
                        >
                    </div>
                    <div class="m-audio__side -back">
                        <img 
                            class="m-audio__image" 
                            :src="step.image2 || step.image1" 
                        >
                        <div class="m-audio__title">{{ step.jargoncard_title }}</div>
                    </div>
                </div>
            </div>
            <audio class="m-audio__player" ref="audioPlayer" controls @play="onPlay" @pause="onPause">
                <source :src="step.audio_file" type="audio/mpeg">
                {{ $t('module.noSupportAudio') }}
            </audio>
            <div class="m-audio__controls u-posRelative">
                <div class="a-iconButton -secondary" @click="flipImage">
                    <i class='bx bx-rotate-right'></i>
                </div>
                <div 
                    class="a-iconButton"
                    :class="{ '-hidden': showImage1 }" 
                    @click="playAudio"
                >
                    <i v-if="!isPlaying" class='bx bx-volume-low'></i>
                    <i v-else class='bx bx-volume-full'></i>
                </div>
            </div>
        </div>
    </div>
    <FixedButton
        :isDisabled="!playedAudio" 
        @click="handleButtonClick"
    >
        {{ $t('module.nextQuestion') }}
    </FixedButton>
</template>

<script setup>
import { ref, inject, onUnmounted } from 'vue';
import { useI18n } from 'vue-i18n';

// Components
import FixedButton from './FixedButton.vue';
import QuestionBox from './QuestionBox.vue';

const completeStep = inject('completeStep');

const props = defineProps({
    step: {
        type: Object,
    },
});

const { t } = useI18n();
const showImage1 = ref(true);
const audioPlayer = ref(null);
const isPlaying = ref(false);
const playedAudio = ref(false);

const flipImage = () => {
    showImage1.value = !showImage1.value;
};

const playAudio = () => {
    if (audioPlayer.value) {
        if (isPlaying.value) {
            audioPlayer.value.pause();
        } else {
            audioPlayer.value.play();
        }
    }
};

const onPlay = () => {
    isPlaying.value = true;
    playedAudio.value = true;
};

const onPause = () => {
    isPlaying.value = false;
};

const handleButtonClick = () => {
    completeStep(props.step.uuid, true);
};

onUnmounted(() => {
    if (audioPlayer.value) {
        audioPlayer.value.removeEventListener("play", onPlay);
        audioPlayer.value.removeEventListener("pause", onPause);
    }
});
</script>